import {
	BRAND_PAGE_ALL_SLUG,
	DOCUMENT_TYPE_BRAND,
	DOCUMENT_TYPE_BRAND_ALL_PAGE,
} from '@/modules/commerce/brand/constants';
import {DOCUMENT_TYPE_CATEGORY} from '@/modules/commerce/category/constants';
import {
	DOCUMENT_TYPE_FAQ,
	DOCUMENT_TYPE_FAQ_ALL_PAGE,
	FAQ_PAGE_ALL_SLUG,
} from '@/modules/commerce/faq/constants';
import {DOCUMENT_TYPE_CAB_FLOOR_MAT_PRODUCT} from '@/modules/commerce/product/cab-floor-mat/schema/names';
import {DOCUMENT_TYPE_CAB_SHOE_TRAY_PRODDUCT} from '@/modules/commerce/product/cab-shoe-tray/schema/names';
import {DOCUMENT_TYPE_CAB_TABLE_PRODDUCT} from '@/modules/commerce/product/cab-table/schema/names';
import {
	DOCUMENT_TYPE_CLOTHING_PRODUCT,
	DOCUMENT_TYPE_CUSTOM_CLOTHING_PRODUCT,
} from '@/modules/commerce/product/clothing/schema/names';
import {DOCUMENT_TYPE_PRODUCT} from '@/modules/commerce/product/product/schema/names';
import {
	DOCUMENT_TYPE_PRODUCT_ALL_PAGE,
	PRODUCT_PAGE_ALL_SLUG,
} from '@/modules/commerce/product/schema/constants';
import {DOCUMENT_TYPE_STICKER_PRODUCT} from '@/modules/commerce/product/stickers/schema/names';
import {DOCUMENT_TYPE_SUBCATEGORY} from '@/modules/commerce/subcategory/constants';
import {
	DOCUMENT_TYPE_TAILORED_INTERIOR_FRONTPAGE,
	TAILORED_INTERIOR_FRONTPAGE_SLUG,
} from '@/modules/commerce/tailored-interior/constants';
import {DOCUMENT_TYPE_VEHICLE_BRAND} from '@/modules/commerce/vehicle-brand/constants';
import {DOCUMENT_TYPE_VEHICLE_TYPE} from '@/modules/commerce/vehicle-type/constants';
import {DOCUMENT_TYPE_FRONTPAGE} from '@/modules/page/sanity/frontpage/constants';
import {DOCUMENT_TYPE_PAGE} from '@/modules/page/sanity/page/constants';
import type {SiteSettingsQueryResult} from '@/sanity/schemas/types';

export const DOCUMENT_HREF_FRAGMENT = `//groq
	"href": "#",
	_type == "${DOCUMENT_TYPE_FRONTPAGE}" => {
		"href": "/"
	},
	_type == "${DOCUMENT_TYPE_PAGE}" => {
		"href": "/" + slug.current
	},
	_type == "${DOCUMENT_TYPE_PRODUCT_ALL_PAGE}" => {
		"href": "/${PRODUCT_PAGE_ALL_SLUG}"
	},
	_type == "${DOCUMENT_TYPE_CATEGORY}" => {
		"href": "/${PRODUCT_PAGE_ALL_SLUG}/" + slug.current
	},
	_type == "${DOCUMENT_TYPE_SUBCATEGORY}" => {
		"href": "/${PRODUCT_PAGE_ALL_SLUG}/" + category->slug.current + "/" + slug.current
	},
	_type == "${DOCUMENT_TYPE_PRODUCT}" ||
	_type =="${DOCUMENT_TYPE_CAB_FLOOR_MAT_PRODUCT}" ||
	_type == "${DOCUMENT_TYPE_CAB_SHOE_TRAY_PRODDUCT}" ||
	_type == "${DOCUMENT_TYPE_CAB_TABLE_PRODDUCT}" ||
	_type == "${DOCUMENT_TYPE_CLOTHING_PRODUCT}" ||
	_type == "${DOCUMENT_TYPE_CUSTOM_CLOTHING_PRODUCT}" ||
	_type == "${DOCUMENT_TYPE_STICKER_PRODUCT}" => {
		"href": "/${PRODUCT_PAGE_ALL_SLUG}/" + category->category->slug.current + "/" + category->slug.current + "/" + slug.current
	},
	_type == "${DOCUMENT_TYPE_FAQ_ALL_PAGE}" => {
		"href": "/${FAQ_PAGE_ALL_SLUG}"
	},
	_type == "${DOCUMENT_TYPE_FAQ}" => {
		"href": "/${FAQ_PAGE_ALL_SLUG}/" + slug.current
	},
	_type == "${DOCUMENT_TYPE_BRAND_ALL_PAGE}" => {
		"href": "/${BRAND_PAGE_ALL_SLUG}"
	},
	_type == "${DOCUMENT_TYPE_BRAND}" => {
		"href": "/${BRAND_PAGE_ALL_SLUG}/" + slug.current
	},
	_type == "${DOCUMENT_TYPE_TAILORED_INTERIOR_FRONTPAGE}" => {
		"href": "/${TAILORED_INTERIOR_FRONTPAGE_SLUG}"
	},
	_type == "${DOCUMENT_TYPE_VEHICLE_TYPE}" => {
		"href": "/${TAILORED_INTERIOR_FRONTPAGE_SLUG}/" + slug.current
	},
	_type == "${DOCUMENT_TYPE_VEHICLE_BRAND}"=> {
		"href": "/${TAILORED_INTERIOR_FRONTPAGE_SLUG}/" + vehicleType->slug.current + "/" + slug.current
	}
`;

export const LINK_FRAGMENT = `//groq
	...,
	reference-> {
		title,
		_type,
		${DOCUMENT_HREF_FRAGMENT}
	}
`;

export type LinkFragment = Omit<
	NonNullable<NonNullable<NonNullable<SiteSettingsQueryResult>['footerLinks']>[number]>,
	'_type' | '_key'
>;

export const linkFragmentToHref = (link: LinkFragment) => {
	if (link.type === 'internal') {
		return link.reference?.href ?? '#';
	}

	if (link.type === 'external') {
		return link.href ?? '#';
	}

	return '#';
};
